import useUser from '../hooks/useUser';
import { useGlobalData } from '../contextProvider/GlobalDataContext';

const rechargeUrl = newParams => {
  const cleanPhone = str => str.replace(/^56/, '');
  const user = useUser();
  const { 'url-iframe-portal-de-recargas': url = '' } = useGlobalData();
  const linea =
    newParams && newParams.linea
      ? cleanPhone(newParams.linea)
      : cleanPhone(user.plan.number);
  const type = user.plan.segment.toLowerCase();

  const params = new URLSearchParams({
    ixemp: 109,
    ver: 'mwm',
    type,
    ...newParams,
    linea,
  });

  return `${url?.iframeURL}?${params.toString()}`;
};

export default rechargeUrl;
